import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { loadParticipantByPtCode } from '../../../store/participantService';
import { reverseFormatDate } from '../../../utils/dateFunctions';

import classes from '../../../commonStyles/tables.module.css';

const AttendanceOutcomeTableRow = ({ row }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USE EFFECTS
    useEffect(() => {
        if (isPTRequestSent && currentParticipant?.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        if (!row?.ptCode) return;
        dispatch(loadParticipantByPtCode(row.ptCode));
        setIsPTRequestSent(true);
    };

    // RENDER
    return (
        <TableRow hover className={classes.basicRowStripes}>
            <TableCell>{row.service}</TableCell>
            <TableCell>{row.adviser}</TableCell>
            <TableCell className={classes.rowLink} onClick={onClickPTCode}>
                {row.ptCode}
            </TableCell>
            <TableCell>{row.uniqueId}</TableCell>
            <TableCell>{row.firstName}</TableCell>
            <TableCell>{row.lastName}</TableCell>
            <TableCell>{row.referralDate ? reverseFormatDate(row.referralDate) : ''}</TableCell>
            <TableCell>{row.currentStatus}</TableCell>
            <TableCell>
                {row.appointmentDate ? reverseFormatDate(row.appointmentDate) : ''}
            </TableCell>
            <TableCell>{row.appointmentTime}</TableCell>
            <TableCell>{row.appointmentType}</TableCell>
            <TableCell>{row.interviewer}</TableCell>
            <TableCell>{row.location}</TableCell>
            <TableCell>{row.appointmentAttendance}</TableCell>
            <TableCell>{row.poNumber}</TableCell>
        </TableRow>
    );
};

AttendanceOutcomeTableRow.propTypes = {
    row: PropTypes.object.isRequired
};

export default AttendanceOutcomeTableRow;
